export const VALID_USER_ROLES = ["airline_user", "etg_user", "etg_admin", "internal_admin", "internal_user"] as const;

export type UserRole = (typeof VALID_USER_ROLES)[number];

export type UserRoleInfo = {
  role: UserRole;
  isAirlineUser: boolean;
  airlineCode?: string;
};
